import React, { useMemo } from 'react';

import { getAppUIVariantConfig } from 'Util/uiVariantSet';
import { calculateLearningModeProgress } from 'Components/ToC/Utils/TocProgressCalculator';
import OnlineSolutionButton from 'Routes/Classroom/Featured/ClearByOnDemand/Container/ClearPlus/OnlineSolutionButton';
import { Box } from 'Components/Base';
import {
  CLEAR_PLUS_TABS,
  useClearPlusByOnDemand,
} from 'Routes/Classroom/Featured/ClearByOnDemand/Contexts/ClearPlusByOnDemandProvider';

import TocFlatted from './TocFlatted';
import TocWithContentTypeIcon from './TocWithContentTypeIcon';
import TocWithRoundedHighlight from './TocWithRoundedHighlight';
import LearningModePanel from './components/LearningModePanel';

/**
 * This is a POC of UI variant set components
 * TODO: Refactor to separate ToC UI and business logic
 */

const OnlineSolutionSection = ({ onClickOnlineSolutionButton }) => {
  const { onOpenDrawer, setActiveTab } = useClearPlusByOnDemand();

  const handleOpenDrawer = () => {
    onOpenDrawer();
    setActiveTab(CLEAR_PLUS_TABS.ONLINE_SOLUTION);
    onClickOnlineSolutionButton();
  };

  return (
    <Box my={5} mx={3}>
      <OnlineSolutionButton
        onlineSolutionButtonProps={{
          style: { width: '100%', backgroundColor: '#F5F7FA', padding: 12, height: 'auto' },
          onClick: handleOpenDrawer,
        }}
      />
    </Box>
  );
};

const ToC = ({
  isSectionGroupActive,
  sectionGroups,
  sections,
  onSectionGroupClick,
  onSectionClick,
  onSubsectionClick,
  currentLearningMode,
  setCurrentLearningMode,
  enabledLearningMode,
  courseLearningModeDetails,
  onClickOnlineSolutionButton,
  isLearnCraftCourse,
  ...props
}) => {
  const { ToCVariant } = getAppUIVariantConfig();

  const learningModeLearningProgressPercentage = useMemo(() => {
    const subsections = sections.flatMap((section) => section?.subsections);
    return calculateLearningModeProgress(subsections, currentLearningMode);
  }, [sections]);

  const learningModeDetailOptions = useMemo(() => {
    const learningModeDetailOptions = courseLearningModeDetails.filter(
      (learningModeDetail) => learningModeDetail.isActive
    );
    return learningModeDetailOptions;
  }, [courseLearningModeDetails]);

  switch (ToCVariant) {
    case 'WithContentTypeIcon': {
      return (
        <TocWithContentTypeIcon
          sections={sections}
          onSubsectionClick={onSubsectionClick}
          {...props}
        />
      );
    }
    case 'WithRoundHighlight': {
      return (
        <TocWithRoundedHighlight
          sections={sections}
          onSubsectionClick={onSubsectionClick}
          {...props}
        />
      );
    }
    case 'Flat':
    default: {
      return (
        <>
          {enabledLearningMode && learningModeDetailOptions.length > 1 && (
            <LearningModePanel
              learningModeDetailOptions={learningModeDetailOptions}
              learningModeLearningProgressPercentage={learningModeLearningProgressPercentage}
              currentLearningMode={currentLearningMode}
              setCurrentLearningMode={setCurrentLearningMode}
            />
          )}
          <TocFlatted
            currentLearningMode={currentLearningMode}
            isSectionGroupActive={isSectionGroupActive}
            sectionGroups={sectionGroups}
            sections={sections}
            onSubsectionClick={onSubsectionClick}
            onSectionClick={onSectionClick}
            onSectionGroupClick={onSectionGroupClick}
            {...props}
          />
          {isLearnCraftCourse && (
            <OnlineSolutionSection onClickOnlineSolutionButton={onClickOnlineSolutionButton} />
          )}
        </>
      );
    }
  }
};

export default ToC;
